import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import classes from "./Logout.module.css";
import { Dropdown } from "react-bootstrap";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { withTranslation } from "react-i18next";
import profile from "../../../assets/images/profile-icon.png";
import support from "../../../assets/images/icon-support.svg";
import plan from "../../../assets/images/icon-plan.svg";
import logout from "../../../assets/images/icon-logout.svg";
import { authProvider } from "../../../store/AuthProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";

interface IStateFromProps {
  t: any;
  config_values: {
    customValue: string | null;
    defaultValue: string;
    element: string;
    elementType: string;
    id: string;
    targetPageTitle: string;
  }[];
  accessTokenParsed:boolean
  impersonate:boolean
}
type Props = IStateFromProps & RouteComponentProps;
class Logout extends Component<Props> {
  // const history = useHistory();
  supportHandler = () => {
    this.props.history.push("/support");
  };
  planHandler = () => {
    this.props.history.push("/myplans");
  };
  handleActionChange = (e) => {};
  handleChange(e: any): void {}
  setLogout = () => {
    window.location.replace("/");
    // todo - remove multiple localstorage keys at a time
    localStorage.clear();
    sessionStorage.clear();
    // localStorage.removeItem("token");
    // localStorage.removeItem("clientName");
    // localStorage.removeItem("userId");
    // localStorage.removeItem("clientId");
  };
  render() {
    const { t } = this.props;
    const buildVersion = `${process.env.REACT_APP_BUILD_VERSION}`;
    let environment = "";
    if (
      process.env.REACT_APP_BUILD_ENVIRONMENT &&
      process.env.REACT_APP_BUILD_ENVIRONMENT.toLowerCase() !== "production"
    ) {
      environment = `${process.env.REACT_APP_BUILD_ENVIRONMENT}`;
    }
    // const elementLabelStyle = {
    //   fontSize: "12px",
    //   fontWeight: "600",
    //   color: "#117093",
    //   marginBottom: "2px",
    // };

    // const elementInputStyle = {
    //   margin: "0",
    //   fontSize: "12px",
    //   padding: "5px 5px",
    //   minHeight: "28px",
    //   borderRadius: "3px",
    // };

    return (
      <li className={classes.userIcon}>
        <Dropdown>
          <Dropdown.Toggle className="btnIcon" id="dropdown-basic-button">
            <Image
              src={profile}
              alt="profile"
              className={classes.iconProfile}
            />
          </Dropdown.Toggle>

          <Dropdown.Menu className={classes.logoutDropdown}>
            <ul className={classes.logoutDropdowns}>
              {/* <li>
              <div className={classes.loginName}>
                John Spencer
                <span>abcxyx@gmail.com</span>
              </div>
            </li> */}
              <li>
                <Dropdown.Item onClick={this.supportHandler}>
                  <Image src={support} alt="support" />
                  {t("header.support")}
                </Dropdown.Item>
              </li>
              <li>
                <Dropdown.Item onClick={this.planHandler}>
                  <Image src={plan} alt="plan" />
                  {this.props.config_values &&
                  this.props.config_values.find(
                    (ele) =>
                      ele.targetPageTitle.toLowerCase() ===
                        "Home".toLowerCase() &&
                      ele.element.toLowerCase() ===
                        "My Plan Screen Name".toLowerCase()
                  )
                    ? this.props.config_values.find(
                        (ele) =>
                          ele.targetPageTitle.toLowerCase() ===
                            "Home".toLowerCase() &&
                          ele.element.toLowerCase() ===
                            "My Plan Screen Name".toLowerCase()
                      )?.customValue
                      ? this.props.config_values
                          .find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Home".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "My Plan Screen Name".toLowerCase()
                          )
                          ?.customValue?.split("\n")
                          .map((item, key) => {
                            return (
                              <span key={key}>
                                {item === "My Plan" ? t("myPlan.title") : item}
                                <br />
                              </span>
                            );
                          })
                      : this.props.config_values
                          .find(
                            (ele) =>
                              ele.targetPageTitle.toLowerCase() ===
                                "Home".toLowerCase() &&
                              ele.element.toLowerCase() ===
                                "My Plan Screen Name".toLowerCase()
                          )
                          ?.defaultValue?.split("\n")
                          .map((item, key) => {
                            return (
                              <span key={key}>
                                {item === "My Plan" ? t("myPlan.title") : item}
                                <br />
                              </span>
                            );
                          })
                    : ``}
                </Dropdown.Item>
              </li>
              <li>
                <LanguageSwitch />
              </li>
              {this.props.impersonate?<li 
              onClick={() => {
                // sessionStorage.removeItem("token")
                sessionStorage.setItem('impersonate',"true")
                window.location.href=`${process.env.REACT_APP_REDIRECT_URL}`
                // window.location.href=`${process.env.REACT_APP_IMPERSONATE_URL}${process.env.REACT_APP_REDIRECT_URL}${process.env.REACT_APP_IMPERSONATE_URL_PARAMS}`
                this.props.history.push("/impersonate");
                return null;  
              }}>
              <div className={classes.langOver}>
              <a className={classes.langDisplay}>
              <i style={{marginRight:'8px'}} className="fa fa-user-secret" aria-hidden="true"></i>
                <span>Impersonate</span>
              </a>
              </div>
              </li>:undefined}
              <li>
                <p></p>
                </li>
              <li className={classes.logout}>
                <Image src={logout} alt="logout" />
                {/* <AzureAD provider={authProvider} forceLogin={true}>
                  {({
                    login,
                    logout,
                    authenticationState,
                    error,
                    accountInfo,
                  }) => {
                    if (AuthenticationState.Authenticated) {
                      const setLogout = () => {
                        logout();
                        // todo - remove multiple localstorage keys at a time
                        // localStorage.clear();
                        localStorage.removeItem("token");
                        localStorage.removeItem("clientName");
                        localStorage.removeItem("userId");
                        localStorage.removeItem("clientId");
                      };
                      return <span onClick={setLogout}>{t('header.logout')}</span>;
                    }
                  }}
                </AzureAD> */}
                <span onClick={this.setLogout}>{t("header.logout")}</span>
              </li>
              <li className={classes.buildVersion}>
                <strong>{t("header.buildVersion")}: </strong> {buildVersion}{" "}
                {environment}
              </li>
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </li>
    );
  }
}
const mapStateToProps = (state: any) => ({
  config_values: state.appConfig.config_values,
  impersonate:state.appConfig.impersonate,
  accessTokenParsed: state.parseAccessToken.accessTokenParsed,
});

export default connect(mapStateToProps)(withRouter(withTranslation()(Logout)));
